"use strict";
// Allow any for validation-functions
/* eslint-disable @typescript-eslint/no-explicit-any */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFieldLecagy_TOBEREMOVED = exports.validateAllFields = exports.validateField = exports.checkHasErrors = exports.validateFnr = exports.validatePasswordConfirm = exports.validatePassword = exports.validateDate = exports.validateRoleArray = exports.validateRole = exports.validateEmail = exports.validateChars = exports.validateRequired = exports.noValidation = void 0;
var objectUtils_1 = require("./objectUtils");
var noValidation = function () { return ({ valid: true, errorTextKey: null }); };
exports.noValidation = noValidation;
var validateRequired = function (text) { return ({
    valid: !!text && text.toString().trim().length >= 1,
    errorTextKey: 'validations.mandatory',
}); };
exports.validateRequired = validateRequired;
var validateChars = function (maxChars) { return function (text) { return ({
    valid: !text || text.length < maxChars,
    errorTextKey: 'validations.text_too_long',
}); }; };
exports.validateChars = validateChars;
var rfcEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var validateEmail = function (email) { return ({
    valid: !email || rfcEmail.test(email.toString()),
    errorTextKey: 'validations.not_valid_email',
}); };
exports.validateEmail = validateEmail;
var validateRole = function (role) { return ({
    valid: !!role && role.toString().trim().length >= 1,
    errorTextKey: 'validations.please_select_role',
}); };
exports.validateRole = validateRole;
var validateRoleArray = function (role) { return ({
    valid: Array.isArray(role) && role.length >= 1,
    errorTextKey: 'validations.please_select_role',
}); };
exports.validateRoleArray = validateRoleArray;
var validateDate = function (date) { return ({
    valid: !date || Date.parse(date.toString()) < 4102444800000,
    errorTextKey: 'validations.notValidDate',
}); };
exports.validateDate = validateDate;
var validatePassword = function (password) { return ({
    valid: !password || password.toString().trim().length >= 8,
    errorTextKey: 'validations.password_must_be_at_least_eight_characters',
}); };
exports.validatePassword = validatePassword;
var validatePasswordConfirm = function (passwordConfirm, allFields, fieldName) { return ({
    valid: (!passwordConfirm && !allFields[fieldName.slice(0, -'Confirm'.length)]) || passwordConfirm === allFields[fieldName.slice(0, -'Confirm'.length)],
    errorTextKey: 'validations.passwords_does_not_match',
}); };
exports.validatePasswordConfirm = validatePasswordConfirm;
var validateFnr = function (fnr) {
    if (!(0, objectUtils_1.hasValue)(fnr)) {
        return {
            valid: true,
            errorTextKey: null,
        };
    }
    var birthNumber = fnr === null || fnr === void 0 ? void 0 : fnr.toString();
    if (!birthNumber || birthNumber.length !== 11) {
        return {
            valid: false,
            errorTextKey: 'validations.notValidFnr',
        };
    }
    var calculate = function (number, factors) {
        var sum = 0;
        for (var i = 0, l = factors.length; i < l; ++i) {
            sum += parseInt(number.charAt(i), 10) * factors[i];
        }
        return sum;
    };
    var checksum1 = 11 - (calculate(birthNumber, [3, 7, 6, 1, 8, 9, 4, 5, 2]) % 11);
    if (checksum1 === 11)
        checksum1 = 0;
    var checksum2 = 11 - (calculate(birthNumber, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]) % 11);
    if (checksum2 === 11)
        checksum2 = 0;
    return {
        valid: checksum1 === parseInt(birthNumber.charAt(9), 10)
            && checksum2 === parseInt(birthNumber.charAt(10), 10),
        errorTextKey: 'validations.notValidFnr',
    };
};
exports.validateFnr = validateFnr;
var checkHasErrors = function (errors) { return Object.keys(errors).reduce(function (prev, key) { return prev || (errors[key] !== null); }, false); };
exports.checkHasErrors = checkHasErrors;
var validateField = function (values, validatorFunction, fieldName) {
    if (!validatorFunction)
        return null;
    var validatorFunctions = Array.isArray(validatorFunction) ? validatorFunction : [validatorFunction];
    var validation = validatorFunctions.reduce(function (prev, currentFunction) {
        if (!currentFunction)
            return prev;
        var currentValidation = currentFunction(values[fieldName], values, fieldName);
        return ({
            valid: prev.valid && currentValidation.valid,
            errorTextKey: prev.valid ? currentValidation.errorTextKey : prev.errorTextKey,
        });
    }, { valid: true, errorTextKey: '' });
    return validation.valid ? null : validation.errorTextKey;
};
exports.validateField = validateField;
var validateAllFields = function (values, validators) { return Object.keys(validators).reduce(function (prev, key) {
    var _a;
    var _b;
    return (validators[key] ? __assign(__assign({}, prev), (_a = {}, _a[key] = (0, exports.validateField)(values, (_b = validators[key]) !== null && _b !== void 0 ? _b : null, key), _a)) : prev);
}, {}); };
exports.validateAllFields = validateAllFields;
// eslint-disable-next-line @typescript-eslint/naming-convention
var validateFieldLecagy_TOBEREMOVED = function (state, validatorFunction, fieldName) {
    var _a;
    var validatorFunctions = validatorFunction ? [].concat(validatorFunction) : [];
    var validation = validatorFunctions.reduce(function (prev, currentFunction) {
        if (!currentFunction)
            return prev;
        // @ts-ignore - legacy function -> To be removed!
        var currentValidation = currentFunction(state[fieldName], state, fieldName);
        return ({
            valid: prev.valid && currentValidation.valid,
            errorTextKey: prev.valid ? currentValidation.errorTextKey : prev.errorTextKey,
        });
    }, { valid: true, errorTextKey: '' });
    var validationErrors = __assign(__assign({}, state.validationErrors), (_a = {}, _a[fieldName] = validation.valid ? null : validation.errorTextKey, _a));
    var hasErrors = Object.keys(validationErrors).reduce(function (prev, key) { return prev || (key !== 'hasErrors' && validationErrors[key] !== null); }, false);
    return __assign(__assign({}, validationErrors), { hasErrors: hasErrors });
};
exports.validateFieldLecagy_TOBEREMOVED = validateFieldLecagy_TOBEREMOVED;
// export const addValidator = (validators, target, ...newValidators) => ({
//     ...validators,
//     [target]: validators[target] ? [].concat(validators[target], newValidators) : newValidators,
// });
